module.exports = __webpack_public_path__ + "static/media/8.265da00d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/8.png
// module id = 1329
// module chunks = 0